<template>
  <AccordionRoot type="single" collapsible>
    <template v-for="item in items" :key="item.question">
      <AccordionItem
        :class="[
          'transition-colors duration-300 w-full my-2 rounded-lg overflow-hidden',
          variant === 'light'
            ? 'bg-head-office-10 hover:bg-white hover:text-primary-100 data-[state=open]:bg-white data-[state=open]:text-primary-100'
            : 'bg-primary-90 theme:bg-theme-20 text-white theme:text-black hover:bg-white hover:text-primary-100 theme:hover:bg-white theme:hover:text-primary-100 data-[state=open]:bg-primary-10 data-[state=open]:text-primary-100 theme:data-[state=open]:bg-white theme:data-[state=open]:text-black data-[state=open]:hover:text-theme-100 theme:data-[state=open]:hover:text-theme-100',
        ]"
        :value="item.question">
        <AccordionHeader>
          <AccordionTrigger class="w-full flex items-center justify-between gap-3 rounded-lg p-5 group cursor-pointer">
            <Typography as="h3" variant="header-5" class="text-left [overflow-wrap:anywhere]">{{
              item.question
            }}</Typography>
            <div
              aria-label="Inklappen / uitklappen"
              class="shrink-0 w-3 h-3 relative  transition-transform duration-200">
              <div class="w-full h-0.5 bg-current absolute top-1/2 -translate-y-1/2" />
              <div
                class="w-full h-0.5 bg-current absolute top-1/2 -translate-y-1/2 rotate-90 group-data-[state=open]:rotate-0 transition-transform duration-200" />
            </div>
          </AccordionTrigger>
        </AccordionHeader>
        <AccordionContent
          class="overflow-hidden data-[state=open]:animate-[slide-down_ease-out] data-[state=closed]:animate-[slide-up_ease-out_forwards]"
          :style="{ animationDuration: mounted ? '300ms' : '0ms' }"
          force-mount>
          <div
            v-if="typeof item.answer === 'string'"
            class="px-5 pb-5 text-body [&_a]:underline [&_a]:underline-offset-2 [&_a:hover]:opacity-80"
            v-html="item.answer" />
          <RichText v-else :text="item.answer" class="px-5 pb-5" />
          <div v-if="item.button" class="px-5 pb-5">
            <slot name="item-button" :button="item.button" />
          </div>
        </AccordionContent>
      </AccordionItem>
    </template>
  </AccordionRoot>
</template>

<script setup lang="ts">
import type { UmbracoRichText } from '@gro-up/types'
import { RichText, Typography } from '@gro-up/ui/primitives'
import { AccordionContent, AccordionHeader, AccordionItem, AccordionRoot, AccordionTrigger } from 'radix-vue'
import { onMounted, ref } from 'vue'

const mounted = ref(false)

onMounted(() => {
  setTimeout(() => {
    mounted.value = true
  }, 300)
})

export type AccordionProps = {
  items: {
    question: string
    answer: string | UmbracoRichText
    button?: unknown
  }[]
  variant?: 'dark' | 'light'
}

const props = withDefaults(defineProps<AccordionProps>(), {
  variant: 'dark',
})
</script>

<style>
@keyframes slide-down {
  from {
    height: 0;
  }
  to {
    height: var(--radix-accordion-content-height);
  }
}

@keyframes slide-up {
  from {
    height: var(--radix-accordion-content-height);
  }
  to {
    height: 0;
  }
}
</style>
